import { observable, action, runInAction } from 'mobx'
import React from 'react'
import Api from '@api/xiu_yan/homeApi'
import homeApi from '@api/home'
import posterApi from '@api/poster'
import mainStore from '@components/Main/store'
import { dGet } from '@core/utils'
import {
  ROLE_SERVICE,
  COUPON_HOME,
  SHOP_PRODUCTS_PATH_A,
  COUPONS_PATH_A,
  SETTLEMENTACCOUNT_UPDATE_PATH_A
} from '@constant'
import { statistic } from '@util'
import { isNormal } from '@merchant-backend/util'
import { zhituibaoModal } from './ZhituibaoModal'

class Store {
  @observable need_upgrade = 0
  @observable hotModalVisible = false // 人气四大弹框
  @observable showModules = []

  /** 获取首页要展示的模块 */
  getShowModules = async () => {
    const { success, data } = await homeApi.homeShowModulesApi()
    if (success) {
      this.showModules = data || []
    }
  }

  @action
  needUpgrade = async () => {
    let {
      data: { need_upgrade }
    } = await Api.siDaUpgrade()
    runInAction(() => {
      if (need_upgrade == 1 && sessionStorage.getItem('isWorkShow') == 1) {
        this.need_upgrade = 1
        sessionStorage.removeItem('isWorkShow')
      } else {
        sessionStorage.setItem('need_upgrade', 0)
        sessionStorage.setItem('special_merchant', 0) //杭州南京的四大金刚商家
      }
    })
  }

  @action
  checkNeed = () => {
    const {
      merchantInfo: { is_new_si_da }
    } = mainStore
    if (is_new_si_da == 1) {
      sessionStorage.setItem('special_merchant', 1) //杭州南京的四大金刚商家
      this.needUpgrade()
    }
  }

  @observable sidaCheck = false
  @action
  changeSida = e => {
    this.sidaCheck = e.target.checked
  }

  @observable
  bankModal = {
    type: 2,
    isShow: false,
    content: '',
    btn1: '',
    btn2: '',
    hrefVal: ''
  }

  @action
  checkBank = () => {
    const {
      merchantInfo: { bank_status }
    } = mainStore

    if (bank_status == 1 || bank_status == 2) {
      this.getBank()
    }
  }

  @observable reason = ''
  @action
  getBank = async () => {
    const {
      merchantInfo: { bank_status, role_user }
    } = mainStore

    const role_user_kind = dGet(role_user, 'kind', ROLE_SERVICE)

    if (role_user_kind != 4) {
      const {
        data: { status, change_protocol, reason }
      } = await Api.bank()

      runInAction(() => {
        if (bank_status == 2 || (bank_status == 1 && status == 2)) {
          this.bankModal = {
            type: 2,
            isShow: true,
            content: (
              <div>
                <p key={1}>
                  {change_protocol == null
                    ? '结算账户绑定未通过'
                    : '修改结算账户绑定未通过'}
                </p>
                <p key={2}>原因：{reason || '无'}</p>
              </div>
            ),
            btn1: '关闭',
            btn2: '重新绑定',
            hrefVal: SETTLEMENTACCOUNT_UPDATE_PATH_A
          }
        }
      })
    }
  }

  @action
  onCancelBank = () => {
    this.bankModal.isShow = false
  }

  @observable holes = []
  @action
  getTouTiao = async () => {
    let {
      data: {
        floors: {
          Merchant_Head_News: { holes }
        }
      }
    } = await posterApi.poster(5002)
    runInAction(() => {
      this.holes = holes || []
    })
  }

  @observable is_overflow = false
  @observable txtWidth = 0

  /**
   * TODO, to be removed
   */
  @action
  onWindowResize = () => {
    const { clientWidth: w = 0 } = document.getElementById('info') || {}
    const infoWidth = w
    if (infoWidth <= 700) {
      this.is_overflow = true
    } else {
      this.is_overflow = false
    }

    const toutiaoWidth = w
    this.txtWidth = toutiaoWidth - 260
  }

  coupons = () => {
    statistic(COUPON_HOME)
    if (isNormal()) {
      window.location.href = SHOP_PRODUCTS_PATH_A
    } else {
      window.location.href = COUPONS_PATH_A
    }
  }

  toggleHotModalVisible = visible => () => {
    this.hotModalVisible = visible
  }

  @action
  getZhituibaoModal = async () => {
    const { data, success } = await homeApi.certifyDataApi()
    if (success) {
      const { router, is_pop_up } = data || {}
      if (router == 'merchantMaterial' && is_pop_up == '1') {
        zhituibaoModal(data)
      }
    }
  }
}

export default new Store()
